module.exports = __webpack_public_path__ + "static/assets/a31ee0ed8dad5e2025398e157f4b4583.svg";